/** 校验字段 key → 页面 ref 后缀（field_xxx）映射；*_other 优先自身，否则回退父级 */
const FIELD_REF_FALLBACK = {
  region_area: 'region',
  region_detail: 'region',
  finance_qualification_other: 'finance_qualifications',
  institution_other: 'institution',
  violation_history_other: 'violation_history',
  live_platform_other: 'live_platforms',
  content_track_other: 'content_tracks',
  association_expectation_other: 'association_expectation',
}

export function resolveFieldRefKey(field) {
  const key = String(field || '').trim()
  if (!key) return ''
  return key
}

export function getFieldRefKeys(field) {
  const key = resolveFieldRefKey(field)
  if (!key) return []
  const keys = [key]
  const fallback = FIELD_REF_FALLBACK[key]
  if (fallback && fallback !== key) keys.push(fallback)
  return keys
}

/**
 * 滚动到表单字段并可选聚焦输入框。
 * @param {Vue} vm 组件实例（需有 $refs）
 * @param {string} field 字段 key
 * @param {{ navOffset?: number }} options
 * @returns {boolean} 是否找到目标节点
 */
export function scrollToFormField(vm, field, options = {}) {
  const navOffset = options.navOffset != null ? options.navOffset : 56
  const refKeys = getFieldRefKeys(field)
  let node = null

  for (let i = 0; i < refKeys.length; i++) {
    const refKey = 'field_' + refKeys[i]
    const el = vm.$refs[refKey]
    const candidate = Array.isArray(el) ? el[0] : el
    if (candidate) {
      node = candidate
      break
    }
  }

  if (!node) return false

  const rect = node.getBoundingClientRect()
  const top = window.pageYOffset + rect.top - navOffset - 16
  window.scrollTo({
    top: Math.max(0, top),
    behavior: 'smooth',
  })

  const input = node.querySelector('input, textarea')
  if (input && typeof input.focus === 'function') {
    setTimeout(() => {
      try {
        input.focus()
      } catch (_) {
        /* ignore */
      }
    }, 320)
  }
  return true
}
